import type { MasterProfile } from "../../../../types";
import { openPdfDocument, renderTable, type PdfRow } from "./pdfShared";

export function exportRelatedCompaniesPdf(
    profile: MasterProfile,
    manualRelatedProfiles: Array<{ profile: MasterProfile; note: string; createdAt: string }>,
    relatedProfiles: MasterProfile[],
) {
    const manualRows: PdfRow = manualRelatedProfiles
        .flatMap(({ profile: linkedProfile, note, createdAt }) => ([
            ["Дружество", linkedProfile.customer] as [string, string],
            ["Профил ID", linkedProfile.profileId] as [string, string],
            ["Магазин", linkedProfile.preferredStore || "Няма"] as [string, string],
            ["Бележка", note || "Няма"] as [string, string],
            ["Добавено", createdAt || "Няма"] as [string, string],
            ["", ""] as [string, string],
        ]))
        .filter(([label, value]) => label !== "" || value !== "");

    const automaticRows: PdfRow = relatedProfiles
        .flatMap((linkedProfile) => ([
            ["Дружество", linkedProfile.customer] as [string, string],
            ["Профил ID", linkedProfile.profileId] as [string, string],
            ["Магазин", linkedProfile.preferredStore || "Няма"] as [string, string],
            ["Канали", linkedProfile.channels || "Няма"] as [string, string],
            ["", ""] as [string, string],
        ]))
        .filter(([label, value]) => label !== "" || value !== "");

    openPdfDocument(
        `Свързани дружества - ${profile.customer}`,
        "Ръчно и автоматично разпознати връзки за Save as PDF.",
        [
            renderTable("Ръчно свързани", manualRows.length > 0 ? manualRows : [["Статус", "Няма ръчно свързани дружества."]]),
            renderTable("Автоматично открити", automaticRows.length > 0 ? automaticRows : [["Статус", "Няма автоматично открити дружества."]]),
        ],
    );
}
